/**
 * Demo access gate.
 *
 * tendra is a static mockup with no backend, so this is a shared-password
 * curtain in front of the demo — not real authentication. The password lives
 * outside the source so it can be rotated per environment:
 *
 *   local dev  → VITE_DEMO_PASSWORD in .env  (see .env.example)
 *   pipeline   → docker build --build-arg VITE_DEMO_PASSWORD="$DEMO_PASSWORD"
 *                (wired in .gitlab-ci.yml, written to .env.local by Dockerfile)
 *
 * It is baked into the bundle at build time and therefore readable by anyone
 * who digs through the JS. It keeps the demo off the open web; it is not a
 * secret and must never be reused for anything real.
 */
const configured = (import.meta.env.VITE_DEMO_PASSWORD ?? '').trim();

/** False when no password was configured at build time — the gate then fails closed. */
export const demoPasswordConfigured = configured.length > 0;

/** Verify a typed password against the configured one. */
export function checkDemoPassword(input: string): boolean {
  return demoPasswordConfigured && input === configured;
}
